export default {
  ROUTE_HOME: 'dae/relatorios'
}



// WEBPACK FOOTER //
// ./src/constants/ma/dadosEstado/financeiro.js